import AntdInput from '@deprecated-ui/common/Input';
import color from '@deprecated-ui/_style/color';
import styled from 'styled-components';

const SearchInput = styled(AntdInput)`
  border: 1px solid ${color.downgray};
  border-radius: 4px;

  :hover {
    border-color: ${color.downgray} !important;
  }

  input::placeholder, input::-webkit-input-placeholder {
    color: #E4E4E4 !important;
  }

  .ant-input-prefix {
    margin-right: 10px
  }

  .ant-input-clear-icon {
    display: flex;
  }
`;

const GifPickerWrapper = styled.div`
  overflow-y: auto;
`;

const MasonryWrapper = styled.div`
  height: 200px;
  overflow-y: auto;
  margin: 0 auto;
`;

const GifWrapper = styled.div`
  cursor: pointer;
`;

export {
  SearchInput,
  GifPickerWrapper,
  MasonryWrapper,
  GifWrapper,
};
